import { render, staticRenderFns } from "./MakePage.vue?vue&type=template&id=b54dbca6"
import script from "./MakePage.vue?vue&type=script&lang=js"
export * from "./MakePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports